import React, { ReactElement } from 'react'
import SectionContainer from '../SectionContainer'
import OperatingSystemsIcon from 'images/integrations/operating-systems.svg'
import ItemContainer from '../ItemContainer'
import Windows from 'images/integrations/operating-systems/windows.svg'
import MacOS from 'images/integrations/operating-systems/mac-os.svg'
import Linux from 'images/integrations/operating-systems/linux.svg'
import iOS from 'images/integrations/operating-systems/ios.svg'
import Android from 'images/integrations/operating-systems/android.svg'

export default function OperatingSystemsSection(): ReactElement {
  return (
    <SectionContainer sectionIcon={OperatingSystemsIcon} title="Operating Systems">
      <ItemContainer icon={Windows} title="Windows" learnMorePath="platform-windows" />
      <ItemContainer icon={MacOS} title="MacOS" learnMorePath="macos-platform" />
      <ItemContainer icon={Linux} title="Linux" learnMorePath="linux-platform" />
      <ItemContainer
        icon={iOS}
        title="iOS"
        learnMorePath="ios-platform"
        sx={{ flex: ['unset', 'unset', 1] }}
      />
      <ItemContainer
        icon={Android}
        title="Android"
        learnMorePath="android-platform"
        sx={{ flex: ['unset', 'unset', 1] }}
      />
    </SectionContainer>
  )
}
